<template>
  <div class="container">
    <div class="top_nav">
      <div class="back" @click="goBack">
        <van-icon class="uploadPage_back" name="arrow-left" />
      </div>
    </div>
    <div class="inner">
      <div class="form">
        <div class="item">
          <div class="left">标题：</div>
          <div class="right">
            <input type="text" maxlength="30" class="title_input" placeholder="标题(必填)" @input="onInputTitle"
              v-model="publishObj.title">
            <div class="input_num">{{ titleLength }} / 30</div>
          </div>
        </div>
        <div class="item">
          <div class="left con_left">内容：</div>
          <div class="right" style="overflow: hidden">
            <myEditor ref="myEditor" :evalue="publishObj.content" />
          </div>
        </div>

        <div class="item">
          <div class="left con_left">选择版块：</div>
          <div class="right ">
            <multiselect class="select_box" v-model="publishObj.topic" placeholder="選擇發布位置" tagPlaceholder="" selectLabel=""
              deselectLabel="" selectedLabel="已选择" label="partitionName" track-by="id" :options="topicList" :multiple="false"
              :taggable="true">
              <!-- <span slot="maxElements"> 最多可以选择三个哦~</span> -->
            </multiselect>
          </div>
        </div>
        <div class="publish_btn" @click="onPublish">發布</div>
      </div>
    </div>
    <div class="loading_box" v-show="loadingFlag">
      <van-loading type="spinner" color="#1989fa" />
    </div>

  </div>
</template>
  
<script>
import myEditor from "./myEditor/pcEditor.vue";

import Multiselect from "vue-multiselect";
import get from "../../api/get";
import qs from "qs";
import * as _code from "../../utils/code";
import { Dialog, Toast } from "vant";




export default {
  name: "postPage",
  components: {
    myEditor,
    Multiselect,
  },
  data() {
    return {
      titleLength: 0,
      publishObj: {
        title: "",
        content: "",
        topic: [],
        upImg: [],
        upVideo: []
      },
      // selectTopic: [],
      brush: true,
      loadingFlag: false,
      topicList: [],
      isEdit: false,
    };
  },
  computed: {},
  created() {
    this.getTopic()
    
  },
  mounted() {
    this.initDraft();
    this.initEdit()

  },
  methods: {
    initEdit() {
      const postId = this.$route.query.postId
      if (postId == undefined) return
      this.isEdit = true
      get.getDetail(postId).then((res) => {
        if (res.data.code == 0) {
          var _data = res.data.data;
          // 给编辑器赋值
          this.publishObj.title = _data.title
          this.publishObj.content = _data.content
          this.$refs.myEditor.editor.setHtml(this.publishObj.content)
          this.publishObj.topic = _data.subjects
          this.myTopic = _data.subjects
          this.publishObj.upImg = _data.pictures
          this.publishObj.upVideo = _data.videos
          this.partitionInfo.item = {};
          this.partitionInfo.item.id = _data.partitionId
          this.partitionInfo.item.partitionName = _data.partitionName
          
        } else if (res.data.code == 1004) {
          this.flag = false;
        } else {
          // this.errorMessage(res.data);
        }
      });
    },
   
    initDraft() {
      const drafts = localStorage.getItem('drafts')
      if (drafts !== null) {
        this.publishObj = JSON.parse(drafts)
        // 获取标题字数
        this.titleLength = this.publishObj.title.length;
        this.partitionInfo.item = drafts.partitionInfo

      } 
    },
    goBack() {
      if (this.isEdit) {
        this.$router.go(-1)
        return
      }
      this.publishObj.content = this.$refs.myEditor.editor.getHtml()
      // this.publishObj.topic = this.selectTopic
      if (this.publishObj.title !== '' || this.publishObj.content.trim() !== '<p><br></p>' || this.publishObj.topic.length !== 0) {
        // 是否保存草稿
        Dialog.confirm({
          message: '将此次编辑保留？',
          cancelButtonText: '不保留',
          confirmButtonText: '保留'
        })
          .then(() => {
            this.publishObj.upImg = this.$refs.myEditor.upImgList
            this.publishObj.upVideo = this.$refs.myEditor.upVideoList
            this.publishObj.partitionInfo = this.partitionInfo.item;
            localStorage.setItem('drafts', JSON.stringify(this.publishObj))
            this.$router.replace('/homePage')
          })
          .catch(() => { 
            localStorage.removeItem('drafts')
            this.$router.replace('/homePage')
          });
      } else {
        this.$router.back()

      }
    },
    getTopic() {
      let _obj = {
        type: 0,
        pageNo: 1,
        pageSize: 100,
      };
      get.partitionList(_obj).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          // this.topicList = data.data
          const topicArr = data.data
          console.log(topicArr);
          topicArr.forEach(item => {
            if (item.canUse === 1) {
              this.topicList.push(item)
            }
          })
        } else {
          // this.errorMessage(data);
        }
      });
    },
    onPublish() {
      if (this.$store.state.postingFlag) {
        const editorImg =  this.$refs.myEditor.editor.getElemsByType('image')
        const editorVideo =  this.$refs.myEditor.editor.getElemsByType('video')
        let upImg = []
        let upVideo = []
        editorImg.forEach(item => {
          upImg.push({path: item.src})
        })

        editorVideo.forEach(item => {
          // 剔除包含iframe的video
          if (item.src.includes('iframe')) return
          upVideo.push({path: item.src})
        })

        this.publishObj.upImg = upImg
        this.publishObj.upVideo = upVideo
        this.publishObj.content = this.$refs.myEditor.editor.getHtml() 
        if (this.brush) {
          this.brush = false;
          if (this.publishObj.title.trim() == "") {
            Toast("请填写标题");
            this.brush = true;
            return;
          }
          // if (this.publishObj.title.trim().length < 4) {
          //   Toast("标题不符合格式");
          //   this.brush = true;
          //   return;
          // }
          if (this.publishObj.content.trim() == "") {
            Toast("内容不能为空");
            this.brush = true;
            return;
          }
          if (!this.publishObj.topic.partitionName) {
            Toast("请選擇發布位置");
            this.brush = true;
            return;
          }

          this.loadingFlag = true;
          let topicArr = [];
          console.log(this.publishObj);
          // this.publishObj.topic.forEach(item => {
          //   topicArr.push(item.id)
          // })
          let publishTopic = topicArr.join(',')
          // 上传的图片和视频都在富文本中捞出来了存在publishObj中
         
          let obj = {
            id: this.isEdit ? this.$route.query.postId : '',
            title: this.publishObj.title,
            description: "",
            content: this.publishObj.content,
            pictures: this.publishObj.upImg.length == 0 ? "" : JSON.stringify(upImg),
            videos: this.publishObj.upVideo.length == 0 ? "" : JSON.stringify(upVideo),
            // subjectIds: publishTopic,
            partitionId : this.publishObj.topic.id,
            source: 'userRichText' // 富文本新增类型字段

          };

          if(this.isEdit) {
            get
            .topicEdit(qs.stringify(obj))
            .then((res) => {
              let data = res.data;
              if (data.code == 0) {
                this.$store.commit("changetipFlag", true);
                setTimeout(() => {
                  this.$store.commit("changetipFlag", false);
                }, 2000);
                this.publickStatus = 1;
                this.$store.commit("changeRefresh", true);
                setTimeout(() => {
                  this.$router.go(-1)
                  this.brush = true;
                }, 100);
                this.loadingFlag = false;
              } else {
                this.loadingFlag = false;
                this.publickStatus = 0;
                let code = data.code;
                let voteErr = _code.code.vote;
                let msg = voteErr[code]
                  ? voteErr[code]
                  : voteErr["other"] + code;
                Toast(msg);
                this.brush = true;
              }
              //回调sdk 分享成功或失败
              // if (sysname === $const.ANDROID || sysname === $const.IPHONE) {
              //   if (iosVersion == "1.2" || iosVersion >= "2.0") {
              //     location.href = "iosn://pd_actv_bbs_share?status="+this.publickStatus;
              //   } else {
              //     window.pd.onBindMobileSuccess && window.pd.onBindMobileSuccess(mobile.value);
              //   }
              // } else if (sysname === $const.U3D_WEB || sysname === $const.U3D_PC) {
              //   window.onBindMobileSuccess();
              // }
            })
            .catch(() => {
              this.loadingFlag = false;
              this.brush = true;
            });

          } else {
            get
            .topicPost(qs.stringify(obj))
            .then((res) => {
              let data = res.data;
              if (data.code == 0) {
                //  發布成功后 清空本地的草稿
                localStorage.removeItem('drafts')

                this.$store.commit("changetipFlag", true);
                setTimeout(() => {
                  this.$store.commit("changetipFlag", false);
                }, 2000);
                this.publickStatus = 1;
                this.$store.commit("changeRefresh", true);
                setTimeout(() => {
                  this.$router.push({
                    name: "homePage",
                  });
                  this.brush = true;
                }, 100);
                this.loadingFlag = false;
              } else {
                this.loadingFlag = false;
                this.publickStatus = 0;
                let code = data.code;
                let voteErr = _code.code.vote;
                let msg = voteErr[code]
                  ? voteErr[code]
                  : voteErr["other"] + code;
                Toast(msg);
                this.brush = true;
              }
              //回调sdk 分享成功或失败
              // if (sysname === $const.ANDROID || sysname === $const.IPHONE) {
              //   if (iosVersion == "1.2" || iosVersion >= "2.0") {
              //     location.href = "iosn://pd_actv_bbs_share?status="+this.publickStatus;
              //   } else {
              //     window.pd.onBindMobileSuccess && window.pd.onBindMobileSuccess(mobile.value);
              //   }
              // } else if (sysname === $const.U3D_WEB || sysname === $const.U3D_PC) {
              //   window.onBindMobileSuccess();
              // }
            })
            .catch(() => {
              this.loadingFlag = false;
              this.brush = true;
            });

          }


          
        }
      } else {
        Toast("功能维护中，暂不支持发帖");
      }



    },
    onInputTitle(e) {
      this.titleLength = this.publishObj.title.length;
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    onSelectTag() {
      console.log(this.publishObj.topic)
      if (this.publishObj.topic.length > 1) {
        this.publishObj.topic.pop()
      }
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  
<style scoped lang="scss">
.a6 {
  color: #a6a6a6;
}

.container {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  /deep/.emo_box {
    z-index: 10;
  }

  .top_nav {
    height: 1.12rem;
    position: relative;
    border-bottom: 1px solid #e7e7e7;

    .back {
      width: 0.21rem;
      height: 0.32rem;
      // background-image: url(../../assets/img/rich/back.png);
      background-size: 100% 100%;
      position: absolute;
      left: 0.3rem;
      bottom: 0;
      margin: auto;
      top: 0;
      cursor: pointer;
    }
  }

  .inner {
    width: 100%;
    max-width: 15rem;
    margin: 0.52rem auto 0;

    .form {
      font-size: 0.26rem;
      padding: 0.3rem;
      background-color: #fff;

      .item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 0.5rem;
        // z-index: 2000;
        // position: relative;

        .left {
          width: 1.5rem;
          font-size: 0.26rem;
          color: #2b2b2b;
          text-align: left;

          &.con_left {
            align-self: flex-start;
            margin-top: 0.1rem;
          }
        }

        .right {
          width: 100%;
          color: #a6a6a6;
          position: relative;
          // overflow: hidden;

          .title_input {
            width: 100%;
            height: 0.6rem;
            line-height: 0.6rem;
            border: 1px solid #e7e7e7;
            color: #000;
            padding-left: 0.3rem;
            padding-right: 1rem;
            box-sizing: border-box;
            &::placeholder {
              color: #d4d4d4
            }
          }

          .input_num {
            position: absolute;
            right: 0.2rem;
            top: 0;
            height: 0.6rem;
            line-height: 0.6rem;
          }

          
        }
      }

      .publish_btn {
        width: 2.66rem;
        height: 0.7rem;
        // background-color: #23323d;
        color: #fff;
        line-height: 0.7rem;
        text-align: center;
        margin: 1.3rem auto;
        cursor: pointer;
      }
    }
  }
}

.gl {
  .select_box {
    width: 5rem;
    cursor: pointer;

    /deep/.multiselect__tag {
      background-color: transparent;
      border: 1px solid #23323d;
      color: #23323d;
    }

    /deep/.multiselect__option--highlight {
      background: #23323d;
    }
    /deep/.multiselect__tag-icon:after {
      color: #23323d;
    }
    /deep/.multiselect__tag-icon:hover {
      &::after {

        color: #fff;
      }
      background: #23323d;
    }
  }
  .publish_btn {
    background-color: #23323d;

  }
  .back {
      background-image: url(../../assets/img/rich/back.png);
  }
  .uploadPage_back {
    display: none;
  }
}
.lzg {
  .select_box {
    width: 5rem;
    cursor: pointer;

    /deep/.multiselect__tag {
      background-color: transparent;
      border: 1px solid #2c89f1;
      color: #2c89f1;
    }

    /deep/.multiselect__option--highlight {
      background: #2c89f1;
    }
    /deep/.multiselect__tag-icon:after {
      color: #2c89f1;
    }
    /deep/.multiselect__tag-icon:hover {
      &::after {

        color: #fff;
      }
      background: #2c89f1;
    }
  }
  .publish_btn {
    background-color: #2c89f1;
  }
  .back {
      background-image: none;
    }
}

.dqss {
  .select_box {
    width: 5rem;
    cursor: pointer;

    /deep/.multiselect__tag {
      background-color: transparent;
      border: 1px solid #00d4a5;
      color: #00d4a5;
    }

    /deep/.multiselect__option--highlight {
      background: #00d4a5;
    }
    /deep/.multiselect__tag-icon:after {
      color: #00d4a5;
    }
    /deep/.multiselect__tag-icon:hover {
      &::after {

        color: #fff;
      }
      background: #00d4a5;
    }
  }
  .publish_btn {
    background-color: #00d4a5;
  }
  .back {
      background-image: none;

    }
}
</style>